module.exports = __webpack_public_path__ + "static/media/td.cb622bc2.svg";